<ngx-datatable
  [messages]="{ emptyMessage: translate.instant('NoData') }"
  #myTable
  class="data-table table-responsive task-list-table"
  [limit]="print ? undefined : 10"
  [columnMode]="'flex'"
  [rows]="topBlockedIps"
  [headerHeight]="'auto'"
  [footerHeight]="50"
>
  <ngx-datatable-column [flexGrow]="4" cellClass="ip" headerClass="ip">
    <ng-template let-column="column" ngx-datatable-header-template>
      {{ 'IP' | translate }}
    </ng-template>
    <ng-template let-row="row" ngx-datatable-cell-template>
      <div [attr.title]="countries.getCountryName(row.countryCode)" class="flex-ip-flag">
        @if (!print) {
          <span
            (click)="!print && clickCountry.emit(row)"
            class="pointer fi fi-{{ row.countryCode?.toLowerCase() }}"
          ></span>
        } @else {
          <span class="country-code">{{ row.countryCode }}</span>
        }
        <a class="clickable client-ip" (click)="!print && clickIp.emit(row)">{{ row.ip }}</a>
      </div>
    </ng-template>
  </ngx-datatable-column>

  <ngx-datatable-column [flexGrow]="7" cellClass="site" headerClass="site">
    <ng-template let-column="column" ngx-datatable-header-template>
      {{ 'Site' | translate }}
    </ng-template>
    <ng-template let-row="row" ngx-datatable-cell-template>
      <span>{{ row.site }}</span>
    </ng-template>
  </ngx-datatable-column>

  <ngx-datatable-column [flexGrow]="3" cellClass="number blocked-by-ai" headerClass="number blocked">
    <ng-template let-column="column" ngx-datatable-header-template>
      {{ 'BlockedByAI' | translate }}
    </ng-template>
    <ng-template let-row="row" ngx-datatable-cell-template>
      <span>{{ row.blockedByBrain | numberFormat }}</span>
    </ng-template>
  </ngx-datatable-column>

  <ngx-datatable-column [flexGrow]="3" cellClass="number geoblocked" headerClass="number blocked">
    <ng-template let-column="column" ngx-datatable-header-template>
      {{ 'Geoblocked' | translate }}
    </ng-template>
    <ng-template let-row="row" ngx-datatable-cell-template>
      <span>{{ row.geoblocked | numberFormat }}</span>
    </ng-template>
  </ngx-datatable-column>

  <ngx-datatable-column [flexGrow]="3" cellClass="number blocked-by-rule" headerClass="number blocked">
    <ng-template let-column="column" ngx-datatable-header-template>
      {{ 'BlockedByRule' | translate }}
    </ng-template>
    <ng-template let-row="row" ngx-datatable-cell-template>
      <span>{{ row.blockedByRule | numberFormat }}</span>
    </ng-template>
  </ngx-datatable-column>

  <ngx-datatable-column [flexGrow]="3" cellClass="number blocked-by-cdn" headerClass="number blocked">
    <ng-template let-column="column" ngx-datatable-header-template>
      <div [title]="'BlockedIpTable.BlockedByCdn.tooltip' | translate">
        {{ 'BlockedIpTable.BlockedByCdn.header' | translate }} <span class="badge badge-sm bg-dark">?</span>
      </div>
    </ng-template>
    <ng-template let-row="row" ngx-datatable-cell-template>
      <span>{{ row.blockedByCdn | numberFormat }}</span>
    </ng-template>
  </ngx-datatable-column>

  <ngx-datatable-column [flexGrow]="3" cellClass="number challenge-emitted" headerClass="number blocked">
    <ng-template let-column="column" ngx-datatable-header-template>
      {{ 'Cause.challengeEmitted' | translate }}
    </ng-template>
    <ng-template let-row="row" ngx-datatable-cell-template>
      <span>{{ row.challengeEmitted | numberFormat }}</span>
    </ng-template>
  </ngx-datatable-column>

  <ngx-datatable-column [flexGrow]="3" cellClass="number suspect" headerClass="number suspect suspicious">
    <ng-template let-column="column" ngx-datatable-header-template>
      {{ 'suspiciouses' | translate }}
    </ng-template>
    <ng-template let-row="row" ngx-datatable-cell-template>
      <span>{{ row.suspicious | numberFormat }}</span>
    </ng-template>
  </ngx-datatable-column>

  <ngx-datatable-column [flexGrow]="3" cellClass="number total" headerClass="number total">
    <ng-template let-column="column" ngx-datatable-header-template>
      {{ 'RequestsTotal' | translate }}
    </ng-template>
    <ng-template let-row="row" ngx-datatable-cell-template>
      <span>{{ row.total | numberFormat }}</span>
    </ng-template>
  </ngx-datatable-column>

  <ngx-datatable-column *ngIf="!print" [flexGrow]="4">
    <ng-template let-column="column" ngx-datatable-header-template>
      {{ 'Actions' | translate }}
    </ng-template>
    <ng-template let-row="row" ngx-datatable-cell-template>
      <a
        class="ogo-link"
        (click)="row.canWhitelistIp && addIpException({ ip: row.ip, site: row.site })"
        [ngStyle]="row.canWhitelistIp ? { cursor: 'pointer' } : { cursor: 'not-allowed', opacity: '0.4' }"
        >{{ 'PutThisIPInWhitelist' | translate }}</a
      >
    </ng-template>
  </ngx-datatable-column>

  <ngx-datatable-footer>
    <ng-template ngx-datatable-footer-template let-rowCount="rowCount" let-curPage="curPage" let-pageSize="pageSize">
      <datatable-pager
        [pagerLeftArrowIcon]="pager.PREV"
        [pagerRightArrowIcon]="pager.NEXT"
        [pagerPreviousIcon]="pager.FIRST"
        [pagerNextIcon]="pager.LAST"
        [page]="curPage"
        [size]="pageSize"
        [count]="rowCount"
        (change)="myTable.onFooterPage($event)"
      />
    </ng-template>
  </ngx-datatable-footer>
</ngx-datatable>
